export const CLINIC_BRAND = "Clínica Dra. Rafaela";
